const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "FETCH_OPTIONS":
      return action.payload;
    case "ADD_OPTION":
      console.log("Adding option in redux");
      return [...state, action.payload];
    case "REMOVE_OPTION":
      console.log("Removing option in redux");
      return state.filter((item) => item.id !== action.payload);
    default:
      return state;
  }
};
